import SCENARIO_TYPES from '../../definitions/scenarioTypes';
import calculateCMHCInsurance from './calculateCMHCInsurance';
import requiresCMHCInsurance from './requiresCMHCInsurance';



/**
 * Calculate mortgage total for given scenario based on provided fields.
 * Represents the total of just the mortgage and not the property.
 *
 * @param {Object} fields
 *
 * @returns {number|null}
 */
function calculateMortgageTotal({
    scenarioType,
    purchasePrice,
    downPayment,
    termInMonths,
    mortgageBalance,
    additionalFunds,
    creditLimit,
}) {
    switch (scenarioType) {
        case SCENARIO_TYPES.PRE_APPROVAL: /* same as purchase */
        case SCENARIO_TYPES.PURCHASE:
            return calculatePurchaseMortgageTotal(purchasePrice, downPayment, termInMonths);
        case SCENARIO_TYPES.RENEWAL:
            return mortgageBalance;
        case SCENARIO_TYPES.REFINANCE:
            return mortgageBalance + additionalFunds;
        case SCENARIO_TYPES.HELOC:
            return creditLimit;
        default:
            return null;
    }
}

function calculatePurchaseMortgageTotal(purchasePrice, downPayment, termInMonths) {
    if (purchasePrice == null || downPayment == null) {
        return null;
    }

    const cmhcInsurance = requiresCMHCInsurance(purchasePrice, downPayment)
        ? calculateCMHCInsurance(purchasePrice, downPayment, termInMonths)
        : 0;

    return downPayment >= purchasePrice * 0.05
        ? Math.max(purchasePrice - downPayment, 0) + cmhcInsurance
        : 0;
}
export { calculatePurchaseMortgageTotal };
export default calculateMortgageTotal;